import Desktop from "./dekstop";
import Mobile from "./mobile";

const NewestReview = (props) => {

	const prop = props;

	if (prop.isMobile) {

		return (
			<Mobile
				{...prop}
			/>
		);

	}
	return (
		<Desktop {...prop} />
	);

};

export default NewestReview;
